import { render } from "./SoundList.vue?vue&type=template&id=40129998"
import script from "./SoundList.vue?vue&type=script&lang=js"
export * from "./SoundList.vue?vue&type=script&lang=js"

import "./SoundList.vue?vue&type=style&index=0&id=40129998&lang=scss"
script.render = render

export default script